import React from "react";
import * as S from "./taskImgPageContent.styles";
import { ReactComponent as IconLeft } from "../../../styles/assets/svg/icon-left-arrow.svg";
import { ReactComponent as IconTime } from "../../../styles/assets/svg/icon-clock.svg";
import { ReactComponent as IconCheck } from "../../../styles/assets/svg/icon-agree.svg";
import { Button } from "../../atoms/Buttons";
import dayjs from "dayjs";
import { ImageType } from "../../../interface/transportation";

interface TaskImgPageContentProps {
  inputRef: any;
  imgArr: ImageType[];
  imgUrl: any;
  isUploading: boolean;
  isEditDelete: boolean;
  isDeleteImg: any[];
  groupedImages: any;
  onChangeImg: (e: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
  handleUploadImage: () => void;
  onSaveHanlder: () => Promise<void>;
  onImgBigHandler: (imgFile: any) => void;
  onImgEditDeleteHandler: () => void;
  onBackPageMoveHanlder: () => void;
  onDeleteImgListSelectedHandler: (data: any) => void;
  onImgDeleteListHandler: () => void;
}

const TaskImgPageContent = ({
  inputRef,
  imgArr,
  imgUrl,
  isUploading,
  isEditDelete,
  isDeleteImg,
  onChangeImg,
  groupedImages,
  handleUploadImage,
  onSaveHanlder,
  onImgBigHandler,
  onImgEditDeleteHandler,
  onBackPageMoveHanlder,
  onDeleteImgListSelectedHandler,
  onImgDeleteListHandler,
}: TaskImgPageContentProps) => {
  return (
    <S.TaskImgPageContentLayout>
      <S.TaskImgPageContentHead>
        <S.TaskImgCountBox>총 {imgArr.length} 건</S.TaskImgCountBox>
        <S.TaskImgButtonBox>
          <S.TaskImgButton onClick={onImgEditDeleteHandler}>
            <label>{isEditDelete ? "취소" : "수정"}</label>
          </S.TaskImgButton>
          {isEditDelete ? (
            isDeleteImg?.length === 0 ? (
              <S.TaskImgButton className="disabledColor">
                <label> 선택삭제 </label>
              </S.TaskImgButton>
            ) : (
              <S.TaskImgButton className="red" onClick={onImgDeleteListHandler}>
                <label> 선택삭제 </label>
              </S.TaskImgButton>
            )
          ) : (
            <S.TaskImgButton className="primary" onClick={handleUploadImage}>
              <label> 사진추가 </label>
            </S.TaskImgButton>
          )}
        </S.TaskImgButtonBox>
      </S.TaskImgPageContentHead>

      <S.TaskImgPageContentBody>
        <input
          id="imgFile"
          type="file"
          ref={inputRef}
          multiple
          accept="image/*"
          onChange={onChangeImg}
        />

        {/* unsaved 이미지 미리보기 영역 */}
        {imgUrl.length > 0 && (
          <S.TaskImgPageContentBodyBox>
            <S.TaskImgUploadsDate>새로 업로드한 이미지</S.TaskImgUploadsDate>
            <S.TaskImgUploadsBox>
              {imgUrl.map((data: any, idx: number) => {
                const isCurrentUploading = isUploading && idx === 0;
                return (
                  <S.ImageContainer
                    key={`new-${idx}`}
                    onClick={() => {
                      if (!isEditDelete) {
                        onImgBigHandler(data);
                      } else {
                        onDeleteImgListSelectedHandler(data);
                      }
                    }}
                  >
                    <S.ImgBox>
                      {isDeleteImg.includes(data) ? (
                        <S.SelectedImg>
                          <IconCheck />
                        </S.SelectedImg>
                      ) : null}
                      {!isCurrentUploading && (
                        <img
                          src={`${process.env.REACT_APP_API_HOST}/${data?.imageUrl}`}
                          alt={idx.toString()}
                        />
                      )}
                    </S.ImgBox>
                    <div>
                      <IconTime />
                      {dayjs(data.updatedAt).format("YYYY-MM-DD HH:mm")}
                    </div>
                  </S.ImageContainer>
                );
              })}
            </S.TaskImgUploadsBox>
          </S.TaskImgPageContentBodyBox>
        )}

        {/* 기존 저장된 이미지 그룹 미리보기 영역 */}
        {Object.keys(groupedImages).map((groupKey: string, idx: number) => (
          <S.TaskImgPageContentBodyBox key={groupKey}>
            <S.TaskImgUploadsDate>
              {groupKey === "LOADING_POINT"
                ? "상차지 등록사진"
                : groupKey === "UNLOADING_POINT"
                ? "하차지 등록사진"
                : groupKey === "RECEIPT"
                ? "인수증 등록사진"
                : "작업지 등록사진"}
            </S.TaskImgUploadsDate>
            <S.TaskImgUploadsBox>
              {groupedImages[groupKey].map((data: any, idx: number) => (
                <S.ImageContainer
                  key={idx}
                  onClick={() => {
                    if (!isEditDelete) {
                      onImgBigHandler(data);
                    } else {
                      onDeleteImgListSelectedHandler(data);
                    }
                  }}
                >
                  <S.ImgBox>
                    {isDeleteImg.includes(data) ? (
                      <S.SelectedImg>
                        <IconCheck />
                      </S.SelectedImg>
                    ) : null}
                    <img
                      src={`${process.env.REACT_APP_API_HOST}/${data?.imageUrl}`}
                      alt={idx.toString()}
                    />
                  </S.ImgBox>
                  <div>
                    <IconTime />
                    {dayjs(data.updatedAt).format("YYYY-MM-DD HH:mm")}
                  </div>
                </S.ImageContainer>
              ))}
            </S.TaskImgUploadsBox>
          </S.TaskImgPageContentBodyBox>
        ))}
      </S.TaskImgPageContentBody>

      <S.TaskImgPageContentBottomBox>
        <div className="small">
          <Button
            type="button"
            size="full"
            color="transparent"
            onClick={onBackPageMoveHanlder}
          >
            <IconLeft width={25} height={25} />
            <p> 이전 </p>
          </Button>
        </div>
        <Button
          type="button"
          size="full"
          color="primary"
          label="저장"
          onClick={onSaveHanlder}
        />
      </S.TaskImgPageContentBottomBox>
    </S.TaskImgPageContentLayout>
  );
};

export default TaskImgPageContent;
